import React from 'react';
import { type BreadcrumbItem } from './BreadcrumbData';

export type { BreadcrumbItem } from './BreadcrumbData';

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
  /** Localized label for the navigation landmark (defaults to English). */
  ariaLabel?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  items,
  className = '',
  ariaLabel = 'Breadcrumb',
}) => (
  <nav className={`card breadcrumbs${className ? ' ' + className : ''}`} aria-label={ariaLabel}>
    <ol className='crumbs'>
      {items.map((item, idx) => (
        <li key={idx}>
          {item.isCurrent ? (
            <span aria-current='page'>{item.label}</span>
          ) : item.href ? (
            <a href={item.href}>{item.label}</a>
          ) : (
            <span>{item.label}</span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export default Breadcrumb;
